import { useDispatch } from "react-redux";
import { useNavigate } from "react-router";
// mui
import { Button, Box, Typography } from "@mui/material";
// axios
import EnhancedAxios from "../../axios/EnhancedAxios";
import { removeUserToken } from "../../redux/features/user/userSlice";
// icons
import { MdLogout } from "react-icons/md";
// alerts
import { askForConfirmationAlert } from "../../utils/alerts/alerts";

const LogoutButton = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const fn = () => {
        EnhancedAxios(null, null)
            .get("/logout")
            .then((response: any) => {
                // console.log(response);
            })
            .catch((error: any) => {
                // errorAlert(error.message);
                // console.log(error);
            })
            .finally(() => {
                dispatch(removeUserToken());
                navigate("/login");
            });
        return 0;
    };
    const handleLogout = () => {
        askForConfirmationAlert("هل انت متاكد", fn);
    };
    return (
        <Box
            component={Button}
            display="flex"
            justifyContent="flex-start"
            alignItems="center"
            gap="10px"
            sx={{
                color: "inherit",
                padding: "8px",
                borderRadius: "5px",
                transition: ".3s ease",
                "&:hover": {
                    backgroundColor: "primary.light",
                },
            }}
            onClick={handleLogout}
        >
            <Typography component="span">
                <MdLogout />
            </Typography>
            <Typography component="span">تسجيل الخروج</Typography>
        </Box>
    );
};

export default LogoutButton;
